export const TAG_GROUP_CRUD_FORM_LOADING = {
    tagGroupCrud: {
        status: "LOADING",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'EDIT'
        },
        payload: null
    }
};
export const TAG_GROUP_CRUD_FORM_CANCEL = () => ({
    tagGroupCrud: {
        status: "",
        meta: {
            title: '',
            button: '',
            type: ''
        },
        payload: null
    }
});
export const TAG_GROUP_CRUD_FORM_CREATE = () => ({
    tagGroupCrud: {
        status: "DONE",
        meta: {
            title: 'Create',
            button: 'save',
            type: 'create'
        },
        payload: null
    }
});
export const TAG_GROUP_CRUD_FORM_EDIT = (payload) => ({
    tagGroupCrud: {
        status: "DONE",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'edit'
        },
        payload: payload
    }
});
export const TAG_GROUP_CRUD_FORM_DELETE = (payload) => ({
    tagGroupCrud: {
        status: "DONE",
        meta: {
            title: 'delete',
            button: 'delete',
            type: 'delete'
        },
        payload: payload
    }
});
export const TAG_GROUP_CRUD_FORM_ERROR = (payload) => ({
    tagGroupCrud: {
        status: "ERROR",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'error'
        },
        payload: payload
    }
});
export const TAG_GROUP_DISPLAY_BAR_LOADING = (payload) => ({
    tagGroups: payload
});
export const TAG_GROUP_DISPLAY_BAR_SHOW = (payload) => ({
    tagGroups: payload
});
export const TAG_GROUP_DISPLAY_BAR_ERROR = (payload) => ({
    tagGroups: payload
});
export const TAG_GROUP_DISPLAY_BAR_DELETED = (payload) => ({
    tagGroups: payload
});
export const TAG_GROUP_CRUD_BAR_LOADING = (payload) => ({
    tagGroups: payload
});